export default __webpack_public_path__ + "static/media/koma_corporation.520f0d12.png";